var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "rollDetail" } },
    [
      _c("c-header-return", { attrs: { title: "ROLL房福利" } }),
      _c("div", { staticClass: "rollDetail-item" }, [
        _c("div", { staticClass: "top-box" }, [
          _c("div", { staticClass: "room-box" }, [
            _c("div", { staticClass: "room-title-box flex flex-center-2" }, [
              _c("div", { staticClass: "room-info" }, [
                _c("div", { staticClass: "room_avatar" }, [
                  _c(
                    "div",
                    {
                      staticClass: "flex flex-center-1",
                      staticStyle: {
                        width: "100%",
                        height: "100%",
                        padding: "0 4px 7px 4px",
                        background: "rgb(26,32,47)",
                      },
                    },
                    [
                      _vm.detailData.avatar
                        ? _c("img", {
                            attrs: {
                              src: _vm._f("imgfilter")(_vm.detailData.avatar),
                              alt: "",
                            },
                          })
                        : [_vm._v(" KJCS2 ")],
                    ],
                    2
                  ),
                  _c("span", [
                    _vm._v(_vm._s(_vm.detailData.isOfficial ? "官方" : "主播")),
                  ]),
                ]),
                _c("div", { staticClass: "room_name" }, [
                  _vm._v(_vm._s(_vm.detailData.name)),
                ]),
              ]),
              _c("div", { staticClass: "time" }, [
                _c("p", { staticClass: "date" }, [
                  _c("span", [_vm._v("开奖时间: ")]),
                  _vm._v(_vm._s(_vm.detailData.time)),
                ]),
                _c("p", { staticClass: "timeInfo" }, [
                  _c("i", [_vm._v(_vm._s(_vm.counterTime.day[0]))]),
                  _c("i", [_vm._v(_vm._s(_vm.counterTime.day[1]))]),
                  _vm._v("天 "),
                  _c("i", [_vm._v(_vm._s(_vm.counterTime.hour[0]))]),
                  _c("i", [_vm._v(_vm._s(_vm.counterTime.hour[1]))]),
                  _vm._v("时 "),
                  _c("i", [_vm._v(_vm._s(_vm.counterTime.min[0]))]),
                  _c("i", [_vm._v(_vm._s(_vm.counterTime.min[1]))]),
                  _vm._v("分 "),
                  _c("i", { staticStyle: { display: "none" } }, [
                    _vm._v(_vm._s(_vm.counterTime.sec)),
                  ]),
                ]),
              ]),
              _c("div", { staticClass: "join-btn" }, [
                _vm.detailData.state === 1
                  ? _c("button", { staticClass: "enter hasEnd" }, [
                      _vm._v("房间结束"),
                    ])
                  : _vm.detailData.filled
                  ? _c("button", { staticClass: "enter hasEnd" }, [
                      _vm._v("房间满员"),
                    ])
                  : _vm.detailData.joined
                  ? _c("button", { staticClass: "enter hasEnd" }, [
                      _c("span", [_vm._v("已经加入")]),
                    ])
                  : _vm.detailData.hasPassword
                  ? _c(
                      "button",
                      {
                        staticClass: "enter",
                        on: { click: _vm.enterPasswordRollRoom },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("@/assets/images/icon/ico_lock.png"),
                            alt: "",
                          },
                        }),
                        _c("span", [_vm._v("立即参与")]),
                      ]
                    )
                  : _c(
                      "button",
                      {
                        staticClass: "enter",
                        on: { click: _vm.enterRollRoom },
                      },
                      [_c("span", [_vm._v("立即参与")])]
                    ),
              ]),
            ]),
            _c("div", { staticClass: "desc-box" }, [
              _c("p", { staticClass: "text" }, [
                _vm._v(_vm._s(_vm.detailData.desc)),
              ]),
            ]),
          ]),
        ]),
        _c("div", { staticClass: "prize-box" }, [
          _c("div", { staticClass: "title" }, [
            _c("span", { staticClass: "head" }, [
              _vm._v("奖品 "),
              _c("strong", [
                _vm._v("(" + _vm._s(_vm.detailData.itemCount) + "件)"),
              ]),
            ]),
            _c("span", { staticClass: "allPrice" }, [
              _vm._v("总价值: "),
              _c("strong", [
                _vm._v(_vm._s(_vm._f("conversion")(_vm.detailData.totalPrice))),
              ]),
            ]),
          ]),
          _c(
            "div",
            { staticClass: "assets-list-box" },
            _vm._l(_vm.detailData.items, function (item, index) {
              return _c(
                "div",
                { staticClass: "assets-listitem" },
                [
                  _c("c-award", {
                    staticClass: "award",
                    attrs: {
                      rarity: item.rarity,
                      picture: item.itemPic
                        ? item.itemPic
                        : require("@/assets/images/icon/cash.png"),
                      name: item.name.match(/^(.*?)\s?(\(.*\))?$/)[1],
                      descriptor: _vm._f("GetItemDuration")(item.name),
                      price: item.price,
                      width: "100%",
                    },
                  }),
                ],
                1
              )
            }),
            0
          ),
        ]),
        _c("div", { staticClass: "member-container" }, [
          !_vm.$screen.mobile
            ? _c("div", { staticClass: "header flex flex-ver" }, [
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        _vm.player_cur_tab = 0
                      },
                    },
                  },
                  [
                    _c("span", { class: { active: _vm.player_cur_tab == 0 } }, [
                      _vm._v("参与名单"),
                    ]),
                  ]
                ),
                _c("div", { staticClass: "line" }),
                _c(
                  "div",
                  {
                    on: {
                      click: function ($event) {
                        _vm.player_cur_tab = 1
                      },
                    },
                  },
                  [
                    _c("span", { class: { active: _vm.player_cur_tab == 1 } }, [
                      _vm._v("获奖名单"),
                    ]),
                  ]
                ),
                _c(
                  "p",
                  [
                    _vm._v("(获奖人员请查看自己的"),
                    _c(
                      "router-link",
                      { attrs: { to: { name: "inventory" } } },
                      [_vm._v("我的库存")]
                    ),
                    _vm._v(")"),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.$screen.mobile
            ? _c("div", { staticClass: "mobileheader" }, [
                _c(
                  "div",
                  { staticClass: "mobileheader-item flex flex-center-3" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "mobilTabitem flex flex-center-1",
                        class: { active: _vm.player_cur_tab == 0 },
                        on: {
                          click: function ($event) {
                            _vm.player_cur_tab = 0
                          },
                        },
                      },
                      [_c("span", [_vm._v("参与名单")])]
                    ),
                    _c("div", { staticClass: "line" }),
                    _c(
                      "div",
                      {
                        staticClass: "mobilTabitem flex flex-center-1",
                        class: { active: _vm.player_cur_tab == 1 },
                        on: {
                          click: function ($event) {
                            _vm.player_cur_tab = 1
                          },
                        },
                      },
                      [_c("span", [_vm._v("获奖名单")])]
                    ),
                  ]
                ),
                _c(
                  "p",
                  [
                    _vm._v("(获奖人员请查看自己的"),
                    _c(
                      "router-link",
                      { attrs: { to: { name: "inventory" } } },
                      [_vm._v("我的库存")]
                    ),
                    _vm._v(")"),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.player_cur_tab == 0
            ? _c(
                "div",
                {
                  staticClass: "member_list_box",
                  on: { scroll: _vm.listenScroll },
                },
                [
                  _c(
                    "ul",
                    { staticClass: "member_list" },
                    _vm._l(_vm.detailData.players, function (item, index) {
                      return _c(
                        "li",
                        [
                          _c("c-avatar", {
                            staticClass: "all-player__player__avatar",
                            attrs: {
                              has_border: false,
                              src: item.avatar,
                              width: "60px",
                            },
                          }),
                          _c("p", { staticClass: "user-name" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                        ],
                        1
                      )
                    }),
                    0
                  ),
                ]
              )
            : _c("div", { staticClass: "member_list_box" }, [
                _c(
                  "ul",
                  { staticClass: "member_list" },
                  [
                    _vm._l(_vm.detailData.winners, function (item, index) {
                      return _c(
                        "li",
                        [
                          _c("c-avatar", {
                            staticClass: "all-player__player__avatar",
                            attrs: {
                              has_border: false,
                              src: item.avatar,
                              width: "60px",
                            },
                          }),
                          _c("p", { staticClass: "user-name" }, [
                            _vm._v(_vm._s(item.name)),
                          ]),
                          _c("p", { staticClass: "user-name" }, [
                            _vm._v(_vm._s(item.itemname)),
                          ]),
                          _c("div", {
                            staticClass: "list-prize-box",
                            style:
                              "background-image: url('" +
                              (item.itempic
                                ? _vm.$imgfilter(item.itempic)
                                : require("@/assets/images/icon/cash.png")) +
                              "');",
                          }),
                        ],
                        1
                      )
                    }),
                    _c("li"),
                    _c("li"),
                    _c("li"),
                    _c("li"),
                    _c("li"),
                    _c("li"),
                    _c("li"),
                    _c("li"),
                    _c("li"),
                    _c("li"),
                  ],
                  2
                ),
              ]),
        ]),
      ]),
      _c(
        "Modal",
        {
          attrs: {
            "class-name": "app-modal",
            "footer-hide": "",
            width: "'400rem'",
            closable: false,
          },
          model: {
            value: _vm.password_room_modal.flag,
            callback: function ($$v) {
              _vm.$set(_vm.password_room_modal, "flag", $$v)
            },
            expression: "password_room_modal.flag",
          },
        },
        [
          _c(
            "c-interactive-panel",
            {
              attrs: { title: "输入房间密码", has_close_button: "" },
              on: {
                close_button_click: function () {
                  return (_vm.password_room_modal.flag = false)
                },
              },
            },
            [
              _c("div", { staticClass: "roll_icon_input" }, [
                _c("i", {
                  staticClass: "ivu-icon ivu-icon-ios-lock-outline",
                  staticStyle: { "font-size": "20px" },
                }),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.password_room_modal.pwd,
                      expression: "password_room_modal.pwd",
                    },
                  ],
                  staticClass: "pad50",
                  attrs: { type: "text", placeholder: "请输入密码" },
                  domProps: { value: _vm.password_room_modal.pwd },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(
                        _vm.password_room_modal,
                        "pwd",
                        $event.target.value
                      )
                    },
                  },
                }),
              ]),
              _c(
                "div",
                {
                  staticClass: "submit-button",
                  staticStyle: { width: "100%" },
                  on: { click: _vm.enterRollRoom },
                },
                [_vm._v("确认")]
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }